import { css } from "@emotion/core";
import { variables, mq } from "../../../cssInJs";

const numberOfTiles = [1, 2, 3];
//const marginLR = [14, 14, 14, 14]
const marginTB = [14, 14, 14];

const widthPercent = (index) => 100 / numberOfTiles[index] + "%";

const linkText = {
  color: "#6e86b3",
  fontSize: "1.3rem",
  lineHeight: "1.2",
  padding: "0 20px",
};

export const tileListStyle = {
  tiles: mq({
    display: "flex",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    //marginLeft: [-marginLR[0] / 2, -marginLR[1] / 2, -marginLR[2] / 2, -marginLR[3] / 2],
    //marginRight: [-marginLR[0] / 2, -marginLR[1] / 2, -marginLR[2] / 2, -marginLR[3] / 2],
    marginTop: [
      marginTB[0] / 2,
      marginTB[1] / 2,
      marginTB[2] / 2,
      marginTB[3] / 2,
    ],
    marginBottom: [
      marginTB[0] / 2,
      marginTB[1] / 2,
      marginTB[2] / 2,
      marginTB[3] / 2,
    ],
    maxWidth: ["960px"],
    margin: "auto",
  }),
  categoryList : mq({
      marginTop: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
      marginBottom: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
      // maxWidth:['800px'],
      maxWidth:['960px'],
      margin: 'auto',
      'div.ff.form-group' : {
        maxWidth: '250px'
      }
    })
};

export const tileStyle = {
  tile: mq({
    paddingLeft: "7px",
    paddingRight: "7px",
    paddingTop: [
      marginTB[0] / 2,
      marginTB[1] / 2,
      marginTB[2] / 2,
      marginTB[3] / 2,
    ],
    paddingBottom: [
      marginTB[0] / 2,
      marginTB[1] / 2,
      marginTB[2] / 2,
      marginTB[3] / 2,
    ],
    maxWidth: [
      widthPercent(0),
      widthPercent(1),
      widthPercent(2),
      widthPercent(3),
    ],
    flexBasis: [
      widthPercent(0),
      widthPercent(1),
      widthPercent(2),
      widthPercent(3),
    ],
    flexGrow: 0,
    flexShrink: 0,
  }),
  container: {
    position: "relative",
    overflow: "hidden",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    background: "#F8F8F8",
    borderRadius: "3px",
    border: "1px solid #f8f8f8",
    "&:hover": {
      "& .productListName, & .productListName a": {
        textDecoration: "none !important",
      },
      "& .productShortDesc, & .productShortDesc a": {
        textDecoration: "none !important",
      },
      "& .discoverMore_button, & .discoverMore_button a": {
        textDecoration: "none !important",
      },
      "& .product__tile__bg": {
        transform: "scale(1.2)",
      },
      "& .productListButton": {
        backgroundColor: "#222d64",
        borderColor: "#222d64",
        ".discoverMore_button": {
          color: "#ffffff",
        },
      },
    },
    "& *": {
      textDecoration: "none !important",
    },
    "& *:hover": {
      textDecoration: "none !important",
    },
  },
  prdImage: {
    position: "relative",
    overflow: "hidden",
    background: "#ffffff",
    padding: "1rem",
    textAlign: "center",
  },
  bg: {
    height: 0,
    paddingBottom: "60%",
    backgroundPosition: "center",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    transition: "transform 0.3s ease",
  },
  name: css({
    fontSize: "1.1rem",
    fontWeight: "bold",
    maxHeight: "48px",
    lineHeight: "1.2",
    color: "#000000",
    textAlign: "left",
    marginBottom: "0.5rem",
    textTransform: "none",
    textDecoration: "none !important",
    "&:hover": {
      textDecoration: "none !important",
    },
    "& a": {
      textDecoration: "none !important",
    },
    "& a:hover": {
      textDecoration: "none !important",
    },
    "@media (max-width: 575.98px)": {
      fontSize: "1.2rem",
    },
  }),
  subtitle: css({
    fontSize: "0.9rem",
    fontWeight: "bold",
    lineHeight: "1.2",
    color: "#000000",
    textAlign: "left",
    marginBottom: "0.5rem",
    marginTop: "0.2rem",
    textDecoration: "none !important",
    "&:hover": {
      textDecoration: "none !important",
    },
    "& a": {
      textDecoration: "none !important",
    },
    "& a:hover": {
      textDecoration: "none !important",
    },
    "@media (max-width: 575.98px)": {
      fontSize: "1rem",
    },
  }),
  shortDes: css({
    lineHeight: "1.4",
    fontSize: "0.8rem",
    color: "#666666",
    textAlign: "left",
    marginBottom: "1rem",
    marginTop: "0",
    textDecoration: "none !important",
    display: "-webkit-box",
    // WebkitLineClamp: 4,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    "&:hover": {
      textDecoration: "none !important",
      color: "#666666",
    },
    "& a": {
      textDecoration: "none !important",
    },
    "& a:hover": {
      textDecoration: "none !important",
    },
  }),
  button: css({
    border: "1px solid #222d64",
    padding: "0.4rem 1.2rem",
    fontSize: "0.9rem",
    display: "inline-block",
    textAlign: "center",
    transition: "all .3s",
    background: "transparent",
    marginTop: "auto",
    borderRadius: "4px",
    ".discoverMore_button": {
      color: "#222d64",
      textDecoration: "none !important",
      "&:hover": {
        textDecoration: "none !important",
        color: "#ffffff",
        backgroundColor: "#222d64",
      },
    },
    "& a": {
      textDecoration: "none !important",
    },
    "& a:hover": {
      textDecoration: "none !important",
    },
  }),
};
